import {
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  InputGroup,
  Tag,
} from "@blueprintjs/core";
import React from "react";

import { inject, observer } from "mobx-react";
import { withRouter } from "react-router";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import cogoToast from "cogo-toast";

class SxBookingMetadata extends React.Component {
  state = {
    collapsed: true,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  diets = [
    "Regular Diet",
    "Low Carb - Diabetic Diet",
    "Renal Diet",
    "Fat Restricted Diet",
    "Salt-Restricted Diet",
    "Low Fiber Diet",
    "Liquid Diet",
    "Soft Diet",
  ];
  anaesthesiaType = [
    "Topical Anaesthesia",
    "Local Anaesthesia",
    "Regional Anaesthesia",
    "General Anaesthesia",
    "Lid Block",
    "Facial Block",
  ];
  eyes = ["Right Eye", "Left Eye", "Both Eyes"];

  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Surgery Metadata
            </Tag>
            <Tag large minimal>
              Eye: {this.props.data.eye}
            </Tag>
            <Tag large minimal>
              Anaesthesia: {this.props.data.anaesthesiaType}
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>{" "}
        </Collapse>
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Surgery Metadata
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <ControlGroup
              vertical
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              <ControlGroup vertical>
                {" "}
                <ControlGroup style={{ marginTop: "5px" }}>
                  {this.props.data.eye ? (
                    <ControlGroup>
                      <Tag
                        icon="eye-on"
                        large
                        intent="success"
                        onRemove={() => {
                          if (this.props.data.lifecycle !== "DRAFT") {
                            cogoToast.error(
                              "Cannot change eye after surgery has been scheduled"
                            );
                            return;
                          }
                          this.props.onUpdate({ eye: null });
                        }}
                      >
                        Eye: {this.props.data.eye}
                      </Tag>
                    </ControlGroup>
                  ) : (
                    <ControlGroup>
                      {" "}
                      <Tag large minimal intent="success">
                        Eye
                      </Tag>
                      <SingleSelectWrapper
                        items={this.eyes}
                        selectedItem={this.props.data.eye}
                        onChange={(eye) => {
                          if (this.props.data.lifecycle !== "DRAFT") {
                            cogoToast.error(
                              "Cannot change eye after surgery has been scheduled"
                            );
                            return;
                          }
                          this.props.onUpdate({ eye: eye });
                        }}
                      />
                    </ControlGroup>
                  )}
                </ControlGroup>
                <ControlGroup style={{ marginTop: "5px" }}>
                  {this.props.data.anaesthesiaType ? (
                    <ControlGroup>
                      <Tag
                        icon="syringe"
                        large
                        intent="primary"
                        style={{ marginRight: "4px" }}
                        onRemove={() => {
                          let terminals = [
                            "DISCHARGED",
                            "LAMA",
                            "DEATH",
                            "CANCELLED",
                          ];
                          if (terminals.includes(this.props.data.lifecycle)) {
                            cogoToast.error(
                              "Cannot change anaesthesia after surgery has been done"
                            );
                            return;
                          }
                          this.props.onUpdate({ anaesthesiaType: null });
                        }}
                      >
                        Anaesthesia: {this.props.data.anaesthesiaType}
                      </Tag>
                    </ControlGroup>
                  ) : (
                    <ControlGroup>
                      {" "}
                      <Tag large minimal intent="primary">
                        Anaesthesia
                      </Tag>
                      <SingleSelectWrapper
                        items={this.anaesthesiaType}
                        selectedItem={this.props.data.anaesthesiaType}
                        onChange={(anaesthesiaType) => {
                          let terminals = [
                            "DISCHARGED",
                            "LAMA",
                            "DEATH",
                            "CANCELLED",
                          ];
                          if (terminals.includes(this.props.data.lifecycle)) {
                            cogoToast.error(
                              "Cannot change anaesthesia after surgery has been done"
                            );
                            return;
                          }
                          this.props.onUpdate({
                            anaesthesiaType: anaesthesiaType,
                          });
                        }}
                      />
                    </ControlGroup>
                  )}
                </ControlGroup>
                <ControlGroup style={{ marginTop: "5px" }}>
                  {this.props.data.diet ? (
                    <ControlGroup>
                      <Tag
                        large
                        icon="unresolve"
                        intent="primary"
                        onRemove={() => {
                          this.props.onUpdate({ diet: null });
                        }}
                      >
                        Diet: {this.props.data.diet}
                      </Tag>
                    </ControlGroup>
                  ) : (
                    <ControlGroup>
                      {" "}
                      <Tag large minimal intent="primary">
                        Diet
                      </Tag>
                      <SingleSelectWrapper
                        items={this.diets}
                        selectedItem={this.props.data.diet}
                        onChange={(diet) => {
                          this.props.onUpdate({ diet: diet });
                        }}
                      />
                    </ControlGroup>
                  )}
                </ControlGroup>
                <ControlGroup style={{ marginTop: "5px" }}>
                  <Tag
                    large
                    interactive
                    onClick={() => {
                      if (this.props.data.lifecycle !== "DRAFT") {
                        cogoToast.error(
                          "Cannot change surgery type has been scheduled"
                        );
                        return;
                      }
                      this.props.onUpdate({
                        isEmergency: !this.props.data.isEmergency,
                      });
                    }}
                    minimal={this.props.data.isEmergency ? false : true}
                    intent={this.props.data.isEmergency ? "danger" : "primary"}
                  >
                    {this.props.data.isEmergency
                      ? "Emergency Surgery"
                      : "Scheduled Surgery"}
                  </Tag>
                </ControlGroup>
                <ControlGroup style={{ marginTop: "5px" }}>
                  <Tag
                    large
                    interactive
                    onClick={() => {
                      this.props.onUpdate({
                        didPatientChooseSurgeon:
                          !this.props.data.didPatientChooseSurgeon,
                      });
                    }}
                    minimal={
                      this.props.data.didPatientChooseSurgeon ? false : true
                    }
                    intent={
                      this.props.data.didPatientChooseSurgeon
                        ? "success"
                        : "primary"
                    }
                  >
                    {this.props.data.didPatientChooseSurgeon
                      ? "Patient Chose Surgeon"
                      : "Counsellor Chose Surgeon"}
                  </Tag>
                </ControlGroup>
              </ControlGroup>
              <ControlGroup style={{ marginTop: "5px" }}>
                <Tag intent="primary" minimal large>
                  Booking Remarks
                </Tag>
                <InputGroup
                  fill
                  value={this.props.data.bookingRemarks}
                  onChange={(event) => {
                    this.props.onUpdate({
                      bookingRemarks: event.target.value,
                    });
                  }}
                />
              </ControlGroup>
            </ControlGroup>
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SxBookingMetadata)));
